module.exports = __webpack_public_path__ + "static/media/topup_health.3dd413df.svg";